// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { boolean, string } from "@altostra/type-validations/lib/primitives";

export const isGenerativeAiAgentsCatalogsResult = objectOf({
  results: arrayOf(
    objectOf({
      name: string,
      has_filtered_sets: boolean,
    })
  ),
});
